import { useState } from 'react';
import { ImFolder } from 'react-icons/im';
import { useDispatch } from 'react-redux';
import LoootyLoader from '../../loader/loootyLoader';
import { deleteFolderAction } from '../../../api/auth';
import { toast } from 'react-toastify';

const DeleteFolder = ({
  toggleShowModal,
  folderData,
  merchandiseList,
  setSelectedFolder,
}) => {
  const dispatch = useDispatch();
  const [fadeOut, setFadeOut] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const deleteFolder = async () => {
    setIsLoading(true);

    await dispatch(
      deleteFolderAction({
        deleteData: {
          id: folderData?.id,
          type: folderData?.type,
        },
      })
    )
      .unwrap()
      .then(() => {
        toast.success('Folder deleted', {
          autoClose: 2000,
          className: 'toast__message',
        });
        setIsLoading(false);
        setSelectedFolder(null);
        setFadeOut((prev) => !prev);
        setTimeout(() => {
          toggleShowModal();
        }, 600);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || 'Error! Try again later', {
          autoClose: 2000,
          className: 'toast__message',
        });
        setIsLoading(false);
      });
  };

  return (
    <div
      className={`reg__sign-up-overlay ${fadeOut ? 'lgn__fade-out-anim' : ''}`}
    >
      <section className='reg__sign-up-modal user__withdrawal-modal'>
        <div className='reg__close-btn-container'>
          <div
            onClick={(e) => {
              setFadeOut((prev) => !prev);
              setTimeout(() => {
                toggleShowModal();
              }, 600);
            }}
            className='reg__close-btn'
          >
            <span className='reg__close-btn-text'>X</span>
          </div>
        </div>

        <div className='reg__sign-up-forms-container withdrawal-modal'>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignContent: 'center',
            }}
          >
            <ImFolder
              className='user__lib-folder-large'
              style={{
                fontSize: '1rem',
                marginRight: '1rem',
                color: '#74747d',
              }}
            />
            <h2 className='user__withdrawal-modal-heading'>Delete Folder</h2>
          </div>

          <div>
            {merchandiseList && merchandiseList.length > 0 ? (
              <p className='user__delete-folder-modal-text'>
                Delete {folderData?.name}? Folder contains products, products
                will be offloaded to the All products default folder if you
                continue
              </p>
            ) : (
              <p className='user__delete-folder-modal-text'>
                Delete {folderData?.name} action is irreversible, continue ?
              </p>
            )}

            <div className='user__delete-folder-btn-container'>
              <button
                className='user__library-trash-btn'
                type='button'
                onClick={() => {
                  setFadeOut((prev) => !prev);
                  setTimeout(() => {
                    toggleShowModal();
                  }, 400);
                }}
              >
                <span className='user__library-trash-btn-text'>Cancel</span>
              </button>

              <div style={{ width: 'fit-content', marginLeft: '1rem' }}>
                <button
                  onClick={deleteFolder}
                  className='user__upload-products-btn'
                  type='button'
                >
                  <div className='user__upload-products-btn-inner'>
                    {isLoading ? <LoootyLoader /> : 'Delete'}
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DeleteFolder;
